<template>
    <div>
        <v-layout justify-center>
            <v-card-actions>
                <v-card 
                    flat
                >
                    <div> {{ intro_current }} </div>
                    
                    <div> {{ intro_passion }} </div>
                </v-card>

            </v-card-actions>
        </v-layout>
        <v-layout justify-center>
            <v-card-actions>
                <a href="https://github.com/lunkaleung" target="_blank"><v-icon x-large>mdi-github</v-icon></a>
                <a href="https://www.linkedin.com/in/lunkaleung" target="_blank"><v-icon x-large>mdi-linkedin</v-icon></a>
                <a href="https://stackoverflow.com/users/2857403/lun" target="_blank"><v-icon x-large>mdi-stack-overflow</v-icon></a>
                <a href="mailto:lunkaleung@gmail.com" target="_blank"><v-icon x-large>mdi-email</v-icon></a>
            </v-card-actions>
        </v-layout>
    </div>
</template>

<script>
export default {
    name: 'About',
    data: () => ({
        intro_current: "Hi there 👋 I am a Cloud DevOps engineer based in Hong Kong.",
        intro_passion: "I am very passionate about System Architecture and Big Data technologies."
    }),
    created() {
        // console.log("About");
    }
}
</script>

<style scoped>
a {
    color: #FFFFFF;
    text-decoration: none;
}
</style>
